import { useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ButtonSpinner from "../Spinner/ButtonSpinner";

const TopNavBar = ({ toggleSidebar, isSidebarVisible, currentpage }) => {
  const navigate = useNavigate();
  const loginUserType = localStorage.getItem("loginusertype");
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const no_ref = useRef(null);
  const infoRef = useRef(null);

  const handleLogout = async () => {
    setLogoutLoading(true);
    localStorage.removeItem("loginuser");
    sessionStorage.removeItem("loginuser");
    localStorage.removeItem("user");
    localStorage.removeItem("company");
    localStorage.removeItem("customerInfo");

    if(loginusertype === "customer"){
    localStorage.removeItem("itemCategoryMaster");
    localStorage.removeItem("itemMaster");
    localStorage.removeItem("branchItemRateMaster");
    localStorage.removeItem("customerItemRateMaster");
    localStorage.removeItem("deliveryTimeSlot");
    }
    navigate("/signin");
    setLogoutLoading(false);
  };

  useEffect(() => {
    if (showLogoutModal) {
      const timer = setTimeout(() => {
        if (no_ref.current) {
          no_ref.current.focus();
        }
      }, 50);

      return () => clearTimeout(timer); // cleanup (good practice)
    }
  }, [showLogoutModal]);

  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  const customerStr = localStorage.getItem("customerInfo");
  const customer = customerStr ? JSON.parse(customerStr) : null;

  const loginusertype = localStorage.getItem("loginusertype");

  return (
    <>
      <nav
        className={`topnavbar d-flex align-items-center navbar navbar-main navbar-expand-lg ${
          !isSidebarVisible ? "px-2" : "px-3"
        } shadow-sm border-radius-xl`}
        id="navbarBlur"
        navbar-scroll="true"
      >
        {/* Hamburger + Current Page */}
        <div className="d-flex align-items-center ">
          {!isSidebarVisible && (
            <div
              className="me-2"
              onClick={toggleSidebar}
              style={{ cursor: "pointer" }}
            >
              <div className="hamburger-icon">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}
          <h5 className="d-md-none d-lg-none mb-0 text-header">
            {currentpage}
          </h5>
        </div>

        {/* Firm Name Centered */}
        <div className="flex-grow-1 d-none d-md-flex justify-content-start">
          <h5 className="mb-0 text-header ">{currentpage}</h5>
        </div>

        <div className="d-flex align-items-center text-primary mt-2 mt-md-0">
          {/* ===== INFO ===== */}

          <ul className="navbar-nav flex-row align-items-center mb-0 pe-md-1 pb-1">
            <li
              className="nav-item ps-3 d-flex align-items-center profile-hover"
              onMouseEnter={() =>
                window.innerWidth >= 992 && setIsProfileOpen(true)
              }
              onMouseLeave={() =>
                window.innerWidth >= 992 && setIsProfileOpen(false)
              }
            >
              {/* PROFILE CLICK FOR SM */}
              <span
                className="nav-link font-weight-bold p-0 d-flex align-items-center cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (window.innerWidth < 992) {
                    setIsProfileOpen((prev) => !prev);
                  }
                }}
              >
                {loginusertype === "delivery" && user?.profile_pic ? (
                  <img
                    src={
                      user.profile_pic
                        ? user.profile_pic
                        : "/assest/user_profile.png"
                    }
                    alt="User Logo"
                    className="topnavbar-profile-img"
                  />
                ) : loginusertype === "customer" && customer?.profileimage ? (
                  <img
                    src={customer.fullprofileimage
                        ? customer.fullprofileimage
                        : "/assest/user_profile.png"}
                    alt="Customer Logo"
                    className="topnavbar-profile-img"
                  />
                ) : (
                  <i className="fa fa-user me-2 text-white"></i>
                )}
                {/* <span className=" text-white">{FirmName}</span> */}
              </span>

              {/* DROPDOWN */}
              {isProfileOpen && (
                <div className="profile-dropdown">
                  <div
                    className="dropdown-item"
                    onClick={() => {
                      setIsProfileOpen(false);
                      if (loginUserType === "delivery") {
                        navigate("/profile");
                      } else {
                        navigate("customer_profile");
                      }
                    }}
                  >
                    <i className="fa fa-user me-2 text-primary"></i>
                    Profile
                  </div>

                  <div
                    className="dropdown-item"
                    onClick={() => {
                      setIsProfileOpen(false);
                      setShowLogoutModal(true);
                    }}
                  >
                    <i className="fa fa-sign-out me-2 text-danger"></i>
                    Logout
                  </div>
                </div>
              )}
            </li>
          </ul>

          <div ref={infoRef} className="position-relative mt-0">
            <span className="bell-wrapper" style={{ cursor: "pointer" }}>
              <i className="fa-solid fa-bell text-theme p-1 font-16"></i>
            </span>
          </div>
          {/* Sidebar toggle (mobile only) */}
          <li className="nav-item d-xl-none ps-1 d-flex align-items-center text-primary pe-3">
            <div
              onClick={toggleSidebar}
              className="nav-link text-body p-0 cursor-pointer"
              id="iconNavbarSidenav"
            >
              <div className="sidenav-toggler-inner">
                <i className="sidenav-toggler-line"></i>
                <i className="sidenav-toggler-line"></i>
                <i className="sidenav-toggler-line"></i>
              </div>
            </div>
          </li>
        </div>
      </nav>

      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">Logout Alert</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to logout?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              ref={no_ref}
              onClick={() => setShowLogoutModal(false)}
              className="no-btn"
            >
              No
            </Button>
            <ButtonSpinner
              type="submit"
              variant="success"
              className="btn btn-success  "
              loading={logoutLoading}
              onClick={handleLogout}
            >
              {logoutLoading ? "Progress..." : "Yes"}
            </ButtonSpinner>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default TopNavBar;
